export const encodeEMailLinkComponent = (component: string): string => {
  return encodeURIComponent(
    component.replace(/\r\n/g, "\n").replace(/\n/g, "\r\n"),
  );
};
